import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';
import { PermissionSchema } from './permissions.js';
import { CapabilityKeySchema } from './settings.js';
export const SessionRoleSchema = z.strictObject({
    id: IdSchema,
    name: z.string(),
});
export const SessionOrganizationSchema = z.strictObject({
    id: IdSchema,
    name: z.string(),
    slug: z.string(),
    roles: z.array(SessionRoleSchema),
});
export const SessionIdentitySchema = z.strictObject({
    id: IdSchema,
    email: z.email().nullable(),
    displayName: z.string(),
});
export const CurrentSessionSchema = z.strictObject({
    identity: SessionIdentitySchema,
    activeOrganizationId: IdSchema,
    /** The caller's membership in the active organization (assignments and notes use it). */
    membershipId: IdSchema,
    /** True inside the shared demo organization, which resets on a schedule. */
    demo: z.boolean(),
    organizations: z.array(SessionOrganizationSchema).min(1),
    permissions: z.array(PermissionSchema),
    /** Optional capabilities enabled for the active organization. */
    capabilities: z.array(CapabilityKeySchema),
    expiresAt: TimestampSchema,
});
export const SwitchOrganizationRequestSchema = z.strictObject({
    organizationId: IdSchema,
});
export const DevelopmentLoginRequestSchema = z.strictObject({
    email: z.email(),
    displayName: z.string().trim().min(1).max(200),
    organizationSlug: z
        .string()
        .trim()
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
});
/** How this environment signs people in; the login page renders accordingly. */
export const AuthModeSchema = z.strictObject({
    mode: z.enum(['oidc', 'development', 'demo']),
    /** The demos this environment offers; the login page picks one by hostname. */
    demos: z.array(z.strictObject({ key: z.string(), name: z.string() })),
    /** In demo mode, where "Get pricing" sends a visitor; null elsewhere. */
    pricingUrl: z.url().nullable(),
});
export const DemoLoginRequestSchema = z.strictObject({
    key: z
        .string()
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
        .optional(),
});
